export const ar = {
  // Common
  "common.back": "رجوع",
  "common.cancel": "إلغاء",
  "common.noItems": "لا توجد عناصر",
  "common.loading": "جاري التحميل...",
  
  // Header
  "nav.features": "الميزات",
  "nav.howItWorks": "كيف يعمل",
  "nav.pricing": "التسعير",
  "nav.faq": "الأسئلة الشائعة",
  "nav.testimonials": "المعرض",
  "nav.contact": "اتصل بنا",
  "button.getStarted": "ابدأ",
  "button.loading": "جاري التحميل...",

  // Auth related
  "auth.signIn": "تسجيل الدخول",
  "auth.redirecting": "جاري إعادة التوجيه...",
  "auth.continueWithGoogle": "متابعة مع Google",
  "auth.continueWithGithub": "متابعة مع GitHub",
  "auth.or": "أو",
  "auth.consent.prefix": "بالمتابعة، فإنك توافق على",
  "auth.consent.terms": "الشروط",
  "auth.consent.and": "و",
  "auth.consent.privacy": "سياسة الخصوصية",

  // Site Title
  "site.title": "Communicate to Win",
  "site.title.first": "Communicate",
  "site.title.second": "to Win",
  "site.title.translated": "沟通制胜",

  // Hero Section
  "hero.title": "مساعد التواصل المدعوم بالذكاء الاصطناعي",
  "hero.subtitle": "حوّل محادثاتك بردود ذكية ومدركة للسياق تساعدك على التواصل بفعالية أكبر في أي موقف.",
  "hero.cta.primary": "ابدأ النسخة التجريبية المجانية",
  "hero.cta.secondary": "شاهد العرض التوضيحي",
  "hero.cta.tryNow": "ابدأ مجاناً",
  "hero.cta.learnMore": "تعلم المزيد",
  "hero.cta.getStarted": "ابدأ مجاناً",
  "hero.preview.primary": "تحسين النبرة",
  "hero.preview.secondary": "ترجمة",
  "hero.preview.tone": "ودود",
  "hero.preview.target": "عميل",
  "hero.hook": "انضم إلى آلاف المستخدمين الذين يحسنون تواصلهم كل يوم.",
  "hero.headline": "مساعد التواصل المدعوم بالذكاء الاصطناعي",
  "hero.subheadline": "حوّل الأفكار الخام إلى ردود مصقولة ومدركة للسياق في ثوانٍ.",
  
  // Stats
  "stats.users": "المستخدمون",
  "stats.replies": "الردود",
  "stats.languages": "اللغات",

  // Main Title
  "main.title": "حوّل كل رد إلى فرصة",

  // Footer Section
  "footer.company": "الشركة",
  "footer.product": "المنتج",
  "footer.support": "الدعم",
  "footer.legal": "قانوني",
  "footer.contactSupport": "اتصل بالدعم",
  "footer.helpCenter": "مركز المساعدة",
  "footer.apiDocs": "وثائق API",
  "footer.statusPage": "صفحة الحالة",
  "footer.privacyPolicy": "سياسة الخصوصية",
  "footer.termsOfService": "شروط الخدمة",
  "footer.cookiePolicy": "سياسة ملفات تعريف الارتباط",
  "footer.refundPolicy": "سياسة الاسترداد",
  "footer.copyright": "© 2025 DOUBLEWIND LTD. All rights reserved.",
  "footer.supportLabel": "الدعم",

  // Features Section
  "features.badge": "ميزات قوية",
  "features.title": "كل ما تحتاجه لتواصل أفضل",
  "features.subtitle": "أدوات شاملة مصممة لجعل كل محادثة أكثر فعالية ومهنية.",
  "features.scenario.title": "قوالب السيناريوهات",
  "features.scenario.description": "قوالب جاهزة للتواصل في مكان العمل والشخصي والأكاديمي والمهني.",
  "features.custom.title": "مدخلات مخصصة",
  "features.custom.description": "الصق أي رسالة أو محتوى واحصل على ردود مناسبة للسياق.",
  "features.instant.title": "قلل وقت الرد بنسبة 90%",
  "features.instant.description": "احصل على ردود مصنوعة بالذكاء الاصطناعي في ثوانٍ قليلة. لا انتظار، نتائج فقط.",
  "features.copy.title": "نسخ ومشاركة بنقرة واحدة",
  "features.copy.description": "انسخ الردود فوراً أو شاركها مباشرة من المنصة.",

  // How It Works Section
  "howItWorks.badge": "كيف يعمل",
  "howItWorks.title": "ثلاث خطوات بسيطة لتواصل أفضل",
  "howItWorks.subtitle": "عمليتنا المبسطة تجعل من السهل إنتاج ردود مهنية لأي موقف.",
  "howItWorks.step1.title": "اختر السيناريو",
  "howItWorks.step1.description": "اختر سيناريو التواصل الذي يناسب احتياجاتك بشكل أفضل.",
  "howItWorks.step2.title": "الصق المحتوى",
  "howItWorks.step2.description": "أضف الرسالة أو المحتوى الذي تحتاج للرد عليه.",
  "howItWorks.step3.title": "احصل على رد الذكاء الاصطناعي",
  "howItWorks.step3.description": "تلقَّ رداً مهنياً وسياقياً في ثوانٍ.",

  // Pricing Section
  "pricing.title": "التسعير",
  "pricing.subtitle": "اختر الخطة التي تناسب احتياجات التواصل الخاصة بك",
  "pricing.plan.free": "Free",
  "pricing.plan.pro": "Pro",
  "pricing.plan.business": "Enterprise",
  "pricing.free.price": "$0",
  "pricing.pro.price": "$9.99",
  "pricing.business.price": "$29.99",
  "pricing.period": "/شهر",
  "pricing.free.description": "مثالي لتجربة خدمتنا",
  "pricing.pro.description": "مثالي للمحترفين والمستخدمين المتكررين",
  "pricing.business.description": "للفرق والمؤسسات",
  "pricing.popular": "الأكثر شعبية",
  "pricing.free.feature1": "10 ردود شهرياً",
  "pricing.free.feature2": "سيناريو أساسي",
  "pricing.free.feature3": "تعريف واستخدام القوالب",
  "pricing.free.feature4": "سجلات الردود التاريخية",
  "pricing.pro.feature1": "200 رد شهرياً",
  "pricing.pro.feature2": "سيناريو أساسي+مخصص",
  "pricing.pro.feature3": "تعريف واستخدام القوالب",
  "pricing.pro.feature4": "سجلات الردود التاريخية",
  "pricing.pro.feature5": "تخصيص متقدم",
  "pricing.business.feature1": "ردود غير محدودة",
  "pricing.business.feature2": "تعاون الفريق",
  "pricing.business.feature3": "سيناريو أساسي+مخصص",
  "pricing.business.feature4": "تعريف واستخدام القوالب",
  "pricing.business.feature5": "سجلات الردود التاريخية",
  "pricing.business.feature6": "تخصيص متقدم",
  "pricing.cta.trial": "ابدأ النسخة التجريبية المجانية",
  "pricing.cta.subscribe": "اشترك",
  "pricing.cta.contact": "اتصل بالمبيعات",
  "pricing.cta.current": "الخطة الحالية",
  "pricing.currentPlan": "الخطة الحالية:",
  "pricing.endDate": "تاريخ انتهاء الخطة الحالية:",
  "pricing.autoRenewalDate": "تاريخ التجديد التلقائي للخطة الحالية:",
  "pricing.answersLeft": "الردود المتبقية:",
  "pricing.planName.free": "خطة Free",
  "pricing.planName.proMonthly": "خطة Pro-شهرية",
  "pricing.planName.proYearly": "خطة Pro-سنوية",
  "pricing.planName.maxMonthly": "خطة Enterprise-شهرية",
  "pricing.planName.maxYearly": "خطة Enterprise-سنوية",
  "pricing.autoRenews": "عدد ردودك يتجدد تلقائياً في:",
  "pricing.needMore": "تحتاج المزيد من الردود؟",
  "pricing.upgradeBelow": "قم بترقية خطتك أدناه",
  "pricing.doNotRollOver": "الردود غير المستخدمة لا تنتقل",
  "pricing.willCancelOn": "سيتم الإلغاء في:",
  "pricing.downgradeScheduled": "تم جدولة التخفيض. سيتم التبديل إلى",
  "pricing.on": "في:",
  "pricing.upgradeImmediateTitle": "تمت ترقية الخطة",
  "pricing.upgradeImmediateDesc": "خطتك الجديدة نشطة الآن.",
  "pricing.downgradeScheduledTitle": "تم جدولة التخفيض",
  "pricing.downgradeScheduledDesc": "ستتغير خطتك في التجديد القادم.",
  "pricing.cancelScheduledTitle": "تم جدولة الإلغاء",
  "pricing.cancelScheduledDesc": "ستنتهي خطتك في نهاية الفترة.",
  "pricing.cancelResumedTitle": "تمت إزالة الإلغاء",
  "pricing.cancelResumedDesc": "سيستمر اشتراكك في التجديد.",
  "pricing.cancelPendingDowngrade": "إلغاء",
  "pricing.pendingDowngradeCanceledTitle": "تم إلغاء التخفيض المُعلق",
  "pricing.pendingDowngradeCanceledDesc": "ستبقى خطتك دون تغيير.",
  "pricing.pendingDowngradeCancelFailedTitle": "فشل الإلغاء",
  "pricing.pendingDowngradeCancelFailedDesc": "تعذر إلغاء التخفيض المُعلق. يرجى المحاولة مرة أخرى.",
  "pricing.cancelPendingDowngradeProcessing": "قيد المعالجة...",
  "pricing.scheduled": "مجدول",
  "pricing.processing": "قيد المعالجة...",
  "pricing.getMoreReplies": "احصل على المزيد من الردود",
  "pricing.oneTimeTitle": "احصل على المزيد من الردود لحسابك",
  "pricing.oneTimeAmountLabel": "المبلغ (USD)",
  "pricing.repliesUnit": "ردود",
  "pricing.oneTimeNotice": "عدد الردود التي تشتريها ساري خلال الدورة الشهرية الحالية. يتطلب استخدامها اشتراكاً مدفوعاً نشطاً ولا تنتقل الردود غير المستخدمة.",
  "pricing.cancel": "إلغاء",
  "pricing.proceed": "متابعة",
  "pricing.confirmUpgradeTitle": "تأكيد الترقية",
  "pricing.confirmDowngradeTitle": "تأكيد التخفيض",
  "pricing.confirmUpgradeDesc": "أنت على وشك ترقية خطتك. يسري التغيير فوراً وقد يتم تطبيق رسوم (أو رصيد) تناسبيّة.",
  "pricing.confirmDowngradeDesc": "أنت على وشك جدولة تخفيض. تبقى ميزاتك الحالية حتى نهاية فترة الفوترة الحالية.",
  "pricing.downgradeEffectNote": "لا يُسترد الدورة الحالية عند التخفيض.",
  "pricing.downgradeApplyNextCycle": "ستبدأ الخطة الجديدة تلقائياً عند التجديد.",
  "pricing.confirmCancel": "رجوع",
  "pricing.confirmProceedUpgrade": "الترقية الآن",
  "pricing.confirmProceedDowngrade": "جدولة التخفيض",

  // FAQ Section
  "faq.title": "الأسئلة الشائعة",
  "faq.subtitle": "كل ما تحتاج لمعرفته حول communicate2win",
  "faq.q1": "ما هي سيناريوهات التواصل المدعومة؟",
  "faq.a1": "نحن ندعم تواصل مكان العمل والعلاقات الشخصية والمراسلات الأكاديمية وخدمة العملاء والتواصل التسويقي والعديد من السيناريوهات الأخرى. ذكاؤنا الاصطناعي يتكيف مع السياق والنبرة المطلوبة لكل موقف.",
  "faq.q2": "ما مدى سرعة إنتاج الردود؟",
  "faq.a2": "ذكاؤنا الاصطناعي ينتج الردود في ثوانٍ قليلة. نحن نعطي الأولوية للسرعة دون التضحية بالجودة، مما يضمن حصولك على ردود مهنية فورية.",
  "faq.q3": "هل يمكنني إلغاء اشتراكي في أي وقت؟",
  "faq.a3": "نعم، يمكنك إلغاء اشتراكك في أي وقت. لا توجد التزامات طويلة الأمد، ويمكنك تخفيض أو ترقية خطتك حسب الحاجة.",
  "faq.q4": "هل بياناتي آمنة وخاصة؟",
  "faq.a4": "نعم، نحن ننفذ تدابير أمنية شاملة تشمل التشفير وضوابط الوصول وعمليات التدقيق الأمني المنتظمة. محتوى الإدخال الخاص بك والردود المولدة يتم تخزينها كجزء من تاريخ المستخدم لتمكين ميزات مثل مراجعة الردود وإنشاء القوالب. يمكنك حذف بيانات التاريخ في أي وقت من خلال إعدادات الحساب.",
  "faq.q5": "ماذا يحدث إذا نفد رصيد الردود لدي؟",
  "faq.a5": "يجب على مستخدمي Free الانتظار حتى بداية الدورة الشهرية التالية لتتجدد حصتهم من الردود. بعد الترقية إلى Pro، إذا نفدت الردود يمكنك شراء ردود إضافية لمرة واحدة؛ هذه الردود الإضافية صالحة فقط خلال الدورة الشهرية الحالية. مشتركو Enterprise لديهم ردود غير محدودة.",
  "faq.q6": "ما هي اللغات المدعومة؟",
  "faq.a6": "حالياً، نحن ندعم الإنجليزية مع خطط للتوسع إلى الإسبانية والفرنسية والألمانية واللغات الرئيسية الأخرى. الذكاء الاصطناعي يمكنه التعامل مع التواصل متعدد اللغات بفعالية.",

  // Testimonials Section
  "testimonials.title": "معرض التواصل",
  "testimonials.subtitle": "رسائل عامة وإيميلات وردود محسنة بالذكاء الاصطناعي لإلهام ردودك الخاصة",
  "testimonials.sarah.name": "سارة جونسون",
  "testimonials.sarah.title": "مديرة التسويق",
  "testimonials.sarah.quote": "communicate2win حوّل طريقة تعاملي مع تواصل العملاء. الردود مهنية وتوفر لي ساعات كل أسبوع.",
  "testimonials.michael.name": "مايكل تشين",
  "testimonials.michael.title": "مدير المبيعات",
  "testimonials.michael.quote": "قوالب سيناريوهات مكان العمل دقيقة بشكل لا يصدق. معدل الاستجابة الخاص بي تحسن بنسبة 40% منذ استخدام هذه الأداة.",
  "testimonials.emily.name": "إميلي رودريغيز",
  "testimonials.emily.title": "قائدة نجاح العملاء",
  "testimonials.emily.quote": "مثالي للتعامل مع مواقف العملاء الصعبة. الذكاء الاصطناعي يفهم السياق والنبرة بشكل مثالي.",
  "testimonials.more": "انقر على المعرض لاستكشاف العروض الكاملة",

  // Interface Elements
  "interface.generating": "جاري إنتاج الرد...",
  "interface.generate": "إنتاج رد بالذكاء الاصطناعي",
  "interface.processing": "جاري المعالجة...",
  "interface.advancedOptions": "خيارات متقدمة",
  "interface.clearInput": "مسح الإدخال",
  "interface.clearDescription": "مسح الوصف",
  // Marquee / Logos
  "marquee.trusted": "شركاء / دعم",
  "marquee.aria": "شعارات العلامات التجارية",

  // History and Showcase
  "history.shareToShowcase": "شارك في المعرض",
  "history.showcased": "في المعرض",
  "history.shareConfirm": "مشاركة هذا المنشور في المعرض؟ هذا الإجراء لا يمكن التراجع عنه إلا إذا حذفت المنشور.",
  "history.sharedBy": "شارك بواسطة:",
  "interface.copy": "نسخ",
  "interface.share": "مشاركة",
  "interface.shareResponse": "مشاركة الرد",
  "interface.shareNative": "مشاركة عبر النظام",
  "interface.shareEmail": "البريد الإلكتروني",
  "interface.copyShareText": "نسخ مع الرابط",
  "interface.shareTextCopied": "تم نسخ الرد والرابط إلى الحافظة.",
  "interface.ready": "جاهز للإنتاج",
  "interface.enterMessage": "أدخل محتوى رسالتك واختر سيناريو للبدء بردود مدعومة بالذكاء الاصطناعي.",
  "interface.fast": "سريع",
  "interface.accurate": "دقيق",
  "interface.professional": "مهني",
  "interface.translation": "ترجمة",
  "interface.responseDescription": "إليك رد مدروس ومهني مصمم للسياق:",
  "interface.multipleOptions": "خيارات ردود متعددة:",
  "interface.option": "خيار",
  "interface.noContent": "لا يوجد محتوى متاح",

  // Placeholders
  "placeholder.message": "الصق الرسالة التي ترد عليها أو محتوى البريد الإلكتروني أو النص الذي تلقيته...",

  // Dropdowns
  "dropdown.useTemplates": "استخدم القوالب",
  "dropdown.scenario": "بلا سيناريو",
  "dropdown.target": "بلا هدف",
  "dropdown.tone": "بلا نبرة",

  // Scenario Options
  "scenario.email": "بريد إلكتروني",
  "scenario.message": "رسالة",
  "scenario.workplace": "مكان العمل",
  "scenario.school": "مدرسة",
  "scenario.home": "منزل",
  "scenario.business": "أعمال",
  "scenario.academic": "أكاديمي",
  "scenario.social": "اجتماعي",
  "scenario.formal": "رسمي",
  "scenario.casual": "غير رسمي",
  "scenario.professional": "مهني",
  "scenario.personal": "شخصي",
  "scenario.customerService": "خدمة العملاء",
  "scenario.interview": "مقابلة",
  "scenario.presentation": "عرض تقديمي",

  // Target Options
  "target.lover": "حبيب",
  "target.friend": "صديق",
  "target.boss": "مدير",
  "target.colleague": "زميل",
  "target.classmate": "زميل دراسة",
  "target.parents": "والدان",
  "target.child": "طفل",
  "target.teacher": "معلم",
  "target.student": "طالب",
  "target.client": "عميل",
  "target.customer": "زبون",
  "target.stranger": "غريب",
  "target.family": "عائلة",
  "target.sibling": "أخ/أخت",
  "target.neighbor": "جار",
  "target.mentor": "موجه",
  "target.supplier": "مورد",
  "target.serviceProvider": "مقدم خدمة",
  "target.partner": "شريك",
  "target.subordinate": "مرؤوس",

  // Tone Options
  "tone.humorous": "فكاهي",
  "tone.serious": "جدي",
  "tone.happy": "سعيد",
  "tone.angry": "غاضب",
  "tone.mischievous": "مؤذ",
  "tone.polite": "مهذب",
  "tone.casual": "غير رسمي",
  "tone.formal": "رسمي",
  "tone.friendly": "ودود",
  "tone.confident": "واثق",
  "tone.apologetic": "معتذر",
  "tone.enthusiastic": "متحمس",

  // Status Messages
  "status.copied": "تم النسخ!",
  "status.copyDescription": "تم نسخ الرد إلى الحافظة.",
  "status.copyWithTranslationDescription": "تم نسخ الرد والترجمة إلى الحافظة.",
  "status.success": "تم إنتاج الرد بنجاح.",
  "status.successWithTranslation": "تم إنتاج الرد مع الترجمة.",
  "status.successWithoutTranslation": "تم إنتاج الرد بنجاح.",
  "status.error": "فشل الإنتاج",
  "status.errorDescription": "فشل في إنتاج الرد. يرجى المحاولة مرة أخرى.",
  "status.enterContent": "يرجى إدخال المحتوى",
  "status.enterContentDescription": "أضف الرسالة التي تريد الرد عليها.",

  // Pro/Max subscriber restrictions
  "restriction.descriptionOptional": "الوصف (اختياري)",
  "restriction.descriptionLabel": "الوصف (للمشتركين في Pro / Enterprise فقط)",
  "restriction.proMaxOnly": "* للمشتركين في Pro / Enterprise فقط",
  "restriction.desPrompt": "أدخل السياق أو معلومات الخلفية أو المتطلبات المحددة التي يمكن أن تساعد في إنتاج ردود أفضل...",

  // Demo functionality for non-logged-in users
  "demo.title": "اختر رسالة للرد عليها",
  "demo.option1": "افتتاحية مبيعات (تواصل بارد)",
  "demo.option2": "التعامل مع استفسار \"سعركم مرتفع\"",
  "demo.option3": "تعريف ذاتي في المقابلة (نسخة 30 ثانية)",
  "demo.option4": "رد بريد إلكتروني",
  "demo.option5": "متابعة لعميل محتمل \"قرأ ولم يرد\"",
  "demo.option6": "عرض المصعد (30 ثانية)",
  "demo.runDemo": "تشغيل العرض التوضيحي",
  "demo.inputContent": "محتوى الإدخال:",
  "demo.scenario": "السيناريو:",
  "demo.target": "الهدف:",
  "demo.tone": "النبرة:",
  "demo.description": "الوصف:",

  // Showcase Page
  "showcase.title": "معرض التواصل",
  "showcase.subtitle": "اكتشف التواصل الملهم المدعوم بالذكاء الاصطناعي الذي شاركته مجتمعنا",
  "showcase.userPrefix": "التواصل العام بواسطة",
  "showcase.backAll": "العودة إلى جميع العروض",
  "showcase.sortBy": "ترتيب حسب:",
  "showcase.sort.newest": "الأحدث أولاً",
  "showcase.sort.oldest": "الأقدم أولاً",
  "showcase.sort.scenario": "حسب السيناريو",
  "showcase.sort.target": "حسب الهدف",
  "showcase.sort.tone": "حسب النبرة",
  "showcase.filter.scenario": "السيناريو:",
  "showcase.filter.target": "الهدف:",
  "showcase.filter.tone": "النبرة:",
  "showcase.filter.all": "الكل",
  "showcase.loading": "جارٍ تحميل المعرض...",
  "showcase.loadingUser": "جارٍ تحميل تواصل المستخدم...",
  "showcase.loadingMore": "جارٍ تحميل المزيد...",
  "showcase.none.userTitle": "لا توجد تواصلات عامة بعد",
  "showcase.none.globalTitle": "لا توجد عناصر في المعرض بعد",
  "showcase.none.userDesc": "هذا المستخدم لم يشارك أي تواصلات في المعرض بعد.",
  "showcase.none.globalDesc": "كن أول من يشارك تواصله المدعوم بالذكاء الاصطناعي في المعرض!",
  "showcase.messageDetails": "تفاصيل الرسالة",
  "showcase.field.date": "التاريخ",
  "showcase.field.scenario": "السيناريو",
  "showcase.field.target": "الهدف",
  "showcase.field.tone": "النبرة",
  "showcase.originalMessage": "الرسالة الأصلية",
  "showcase.description": "الوصف",
  "showcase.aiResponse": "رد الذكاء الاصطناعي",

  // Templates
  "templates.saveAsTemplate": "حفظ كقالب",
  "templates.saved": "تم حفظ القالب",
  "templates.saveSuccess": "تم حفظ القالب بنجاح",
  "templates.title": "قوالبي",
  "templates.new": "قالب جديد",
  "templates.loading": "جارٍ التحميل...",
  "templates.none": "لم يتم العثور على قوالب",
  "templates.name": "الاسم",
  "templates.scenario": "السيناريو",
  "templates.target": "الهدف",
  "templates.tone": "النبرة",
  "templates.description": "الوصف",
  "templates.save": "حفظ",
  "templates.saving": "جارٍ الحفظ...",
  "templates.delete": "حذف القالب",
  "templates.deleteConfirm": "حذف هذا القالب؟",
  "templates.deleteFailed": "فشل في حذف القالب",
  "templates.nameRequired": "* يرجى إدخال اسم القالب",
  "templates.deleteSuccess": "تم حذف القالب بنجاح",

  // History Modal additions
  "history.messageDetails": "تفاصيل الرسالة",
  "history.messageDetailsDesc": "عرض وإدارة تفاصيل الرسالة، بما في ذلك الإدخال الأصلي ورد الذكاء الاصطناعي.",
  "history.field.date": "التاريخ",
  "history.field.scenario": "السيناريو",
  "history.field.target": "الهدف",
  "history.field.tone": "النبرة",
  "history.originalMessage": "الرسالة الأصلية",
  "history.aiResponse": "رد الذكاء الاصطناعي",
  "history.description": "الوصف",
  "history.listTitle": "سجل الرسائل",
  "history.listDesc": "تصفح وفلتر وإدارة سجل محادثاتك. انقر على أي رسالة لعرض التفاصيل.",
  "history.sortBy": "ترتيب حسب:",
  "history.sort.newest": "الأحدث أولاً",
  "history.sort.oldest": "الأقدم أولاً",
  "history.sort.scenario": "حسب السيناريو",
  "history.sort.target": "حسب الهدف",
  "history.sort.tone": "حسب النبرة",
  "history.filter.scenario": "السيناريو:",
  "history.filter.target": "الهدف:",
  "history.filter.tone": "النبرة:",
  "history.filter.all": "الكل",
  "history.loading": "جارٍ تحميل السجل...",
  "history.loadingMore": "جارٍ تحميل المزيد...",
  "history.none": "لم يتم العثور على رسائل",
  "history.showing": "عرض {current} من أصل {total} رسائل",
  "history.allLoaded": "تم تحميل جميع الرسائل",
  "history.scrollMore": "مرر للأسفل للمزيد",
  "history.loadMoreButton": "تحميل المزيد",
  "history.deleteMessage": "حذف الرسالة",
  "history.deleting": "جارٍ الحذف...",
  "history.deleteSuccess": "تم حذف سجل الرسالة بنجاح",
  "history.deleteFailed": "فشل في حذف سجل الرسالة، يرجى المحاولة مرة أخرى",
  "history.confirmDeleteTitle": "تأكيد الحذف",
  "history.confirmDeleteSubtitle": "لا يمكن التراجع عن هذا الإجراء",
  "history.confirmDeleteDesc": "هل أنت متأكد من رغبتك في حذف سجل هذه الرسالة؟",
  "history.confirmDeleteAction": "تأكيد الحذف",
  "history.shareTitle": "مشاركة في المعرض",
  "history.shareSubtitle": "جعل هذه الرسالة عامة",
  "history.sharing": "جارٍ المشاركة...",
  "history.confirmShareAction": "تأكيد المشاركة",
  "history.shareSuccess": "تمت مشاركة الرسالة في المعرض بنجاح",
  "history.shareFailed": "فشل في المشاركة في المعرض، يرجى المحاولة مرة أخرى",
  "templates.saveFailed": "فشل في حفظ القالب",

  // User Menu
  "userMenu.myAccount": "حسابي",
  "userMenu.history": "السجل",
  "userMenu.templates": "القوالب",
  "userMenu.signOut": "تسجيل الخروج",
  
  // Hero Showcase / Demo Tabs / Previews
  "hero.preview.aiReply": "معاينة رد الذكاء الاصطناعي",
  "hero.preview.scenarioLabel": "السيناريو",
  // Demo short tab titles (mapped from demo option ids)
  "demo.shortTitle.salesOpener": "افتتاحية مبيعات",
  "demo.shortTitle.priceObjection": "استفسار السعر",
  "demo.shortTitle.interviewIntro": "مقدمة المقابلة",
  "demo.shortTitle.emailReply": "رد بريد إلكتروني",
  "demo.shortTitle.followUp": "متابعة",
  "demo.shortTitle.elevatorPitch": "عرض المصعد",
  // Demo path / response overlay
  "demoTabs.pathPrefix": "demo",
  "demoTabs.response": "response",
  "demoTabs.inputPrompt": "موجه الإدخال",
  "demoTabs.context": "السياق",
  "demoTabs.description": "الوصف",
  "demoTabs.generate": "توليد",
  "demoTabs.aiOutput": "إخراج الذكاء الاصطناعي",
  "demoTabs.sample": "نموذج",
  "demoTabs.streaming": "تدفق الرموز...",
  "preview.section.scenarioTemplates.title": "السيناريو والقوالب",
  "preview.section.scenarioTemplates.subtitle": "اختر سيناريو بسرعة أو طبق قالب محفوظ. القوالب تملأ الوصف/الهدف/النبرة مسبقاً حتى تدخل توليد عالي الجودة فوراً.",
  "preview.section.customInputs.title": "مدخلات مخصصة",
  "preview.section.customInputs.subtitle": "المدخل الأساسي + الوصف الاختياري + محددات السيناريو/الهدف/النبرة المتقدمة. اجمعها بحرية للحصول على نتائج مدركة للسياق.",
  "preview.section.cutReplyTime.title": "تقليل وقت الرد بنسبة 90%",
  "preview.section.cutReplyTime.subtitle": "قارن بين الصياغة اليدوية والمساعدة بالذكاء الاصطناعي. خيارات متوازية + حلقات ترجمة أو مراجعة مدمجة.",
  "preview.section.copyShare.title": "نسخ ومشاركة بنقرة واحدة",
  "preview.section.copyShare.subtitle": "خيارات متعددة مرتبة مع إجراءات علوية موحدة: نسخ الكل / مشاركة / نسخ لكل خيار. الترجمة ملحقة تلقائياً.",
  "preview.templates.my": "قوالبي",
  "preview.templates.new": "جديد",
  "preview.manualFlow": "التدفق اليدوي",
  "preview.aiAssisted": "بمساعدة الذكاء الاصطناعي",
  // Manual flow bullet steps
  "preview.manualFlow.step1": "خطط للهيكل والنبرة",
  "preview.manualFlow.step2": "صيغ الافتتاح / احذف وأعد كتابة",
  "preview.manualFlow.step3": "اضبط الأدب والقواعد النحوية",
  "preview.manualFlow.step4": "ابحث عن الصياغة + تحقق من الترجمة",
  "preview.manualFlow.step5": "الصق في التطبيق المستهدف",
  "preview.copyAll": "نسخ الكل",
  "preview.share": "مشاركة",
  "preview.enPlusTranslation": "الإنجليزية + الترجمة",
  "preview.translationAppendNote": "(*) الترجمة ملحقة تلقائياً عند النسخ بالكامل.",
  "preview.field.scenario": "السيناريو",
  "preview.field.target": "الهدف",
  "preview.field.tone": "النبرة",
  "preview.auto": "تلقائي",
  "preview.step.pasteOrTemplate": "الصق الطلب أو اختر قالب",
  "preview.step.optionalDescription": "(اختياري) أضف الوصف/السيناريو",
  "preview.step.pickOption": "اختر إحدى الخيارات المولدة",
  "preview.step.copyShareTranslate": "نسخ/مشاركة/ترجمة بنقرة واحدة",
  "preview.time.manual": "5–8 دقائق",
  "preview.time.ai": "30–40 ثانية"
};